import React from 'react';
import TextEditor from './TextEditor';
const DraftSheetMain = () => {
    return <>
        <section className={`bpl-container`}>
            <TextEditor />
        </section>
    </>
}

export default DraftSheetMain;